import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { FooterBottomComponent } from '../../../app/content/layout/components/general/footer/components/footer-bottom/footer-bottom.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<FooterBottomComponent> = {
  title: 'Organisms/Footer/Footer Bottom',
  component: FooterBottomComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<FooterBottomComponent>;

export const Default: Story = {
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-footer-bottom')).toBeTruthy();
  },
};
